import * as THREE from 'three';
import { ValidationResult } from './types';
import { convertMMLToThreeJS as convertImpl } from './converter';
import { validateMML as validateImpl } from './validator';

const isBrowser = typeof window !== 'undefined';

export function convertMMLToThreeJS(mmlCode: string): THREE.Object3D {
  if (!isBrowser) {
    return new THREE.Group();
  }

  try {
    const result = convertImpl(mmlCode);

    if (!result.validationResult.isValid) {
      console.warn('MML validation errors:', result.validationResult.errors);
    }

    return result.object;
  } catch (error: any) {
    console.error('Error converting MML to ThreeJS:', error.message || error);
    return new THREE.Group();
  }
}

export function validateMML(mmlCode: string): ValidationResult | null {
  if (!isBrowser) {
    return null;
  }

  return validateImpl(mmlCode);
}
